import apiClient from "./apiClient";

export function login({ mobile, password }) {
  return apiClient.post("/auth/login", { mobile, password });
}

export function signup({ name, mobile, email, password, role }) {
  return apiClient.post("/auth/signup", { name, mobile, email, password, role });
}

export function getProfile() {
  return apiClient.get("/auth/profile");
}
